import { useMutation } from "@tanstack/react-query";
import { APP_THEME } from "AppTheme/constants";
import controllerAPI from "Utils/API/Controller";
import { Notification } from 'Widgets/Notification';
export const useCreateFeedbackMutation = () => {
    const environmentInformation = `\n\nReported from: ${encodeURI(window.location.href)}`;
    return useMutation({
        mutationFn: async ({ summary, description }) => {
            const feedback = { title: summary, body: description + environmentInformation };
            Notification.info({
                theme: APP_THEME,
                message: "Submitting feedback..."
            });
            return controllerAPI.postFeedback(feedback);
        },
        onSuccess: () => {
            Notification.success({
                theme: APP_THEME,
                message: "Feedback submitted successfully!"
            });
        },
        onError: (error) => {
            Notification.error({
                theme: APP_THEME,
                message: `Failed to submit feedback: ${error.message || "Unknown error"}`
            });
        },
    });
};
